<script setup>
import { computed } from 'vue';
import Icon from 'dashboard/components-next/icon/Icon.vue';

const props = defineProps({
  index: {
    type: Number,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  // 'done' | 'active' | 'pending'. A pending step renders as its title alone: the
  // instructions for a step the admin cannot act on yet are noise.
  state: {
    type: String,
    default: 'pending',
    validator: value => ['done', 'active', 'pending'].includes(value),
  },
  failed: {
    type: Boolean,
    default: false,
  },
});

const markerClass = computed(() => {
  if (props.failed && props.state === 'active') {
    return 'text-n-ruby-11 bg-n-ruby-3';
  }
  if (props.state === 'done') return 'text-n-teal-11 bg-n-teal-3';
  if (props.state === 'active') return 'text-white bg-n-brand';
  return 'text-n-slate-10 bg-n-alpha-2';
});
</script>

<template>
  <section
    class="flex gap-4 p-4 border rounded-xl"
    :class="state === 'active' ? 'border-n-brand' : 'border-n-weak'"
    :data-testid="`migration-step-${index}`"
    :data-state="state"
  >
    <span
      class="flex items-center justify-center text-xs font-medium rounded-full size-6 shrink-0"
      :class="markerClass"
    >
      <Icon v-if="state === 'done'" icon="i-lucide-check" class="size-3.5" />
      <Icon
        v-else-if="failed && state === 'active'"
        icon="i-lucide-triangle-alert"
        class="size-3.5"
      />
      <template v-else>{{ index }}</template>
    </span>

    <div class="flex flex-col flex-1 min-w-0 gap-3">
      <h3
        class="text-sm font-medium"
        :class="state === 'pending' ? 'text-n-slate-10' : 'text-n-slate-12'"
      >
        {{ title }}
      </h3>
      <slot v-if="state !== 'pending'" />
    </div>
  </section>
</template>
